module.exports = __webpack_public_path__ + "img/img02.9aa17fdf.jpg";